module.exports = __webpack_public_path__ + "img/ky-qt.14a49845.png";